import { fork, all } from 'redux-saga/effects';
import userRootSaga from 'modules/user/sagas';
import notificationRootSaga from 'modules/notifications';
import downloadFileRootSaga from 'modules/download-file';
import confirmationRootSaga from 'modules/confirmation/saga';
import engineBuildsRootSaga from 'modules/engine-builds/sagas';

export default function* root() {
  yield all([
    fork(userRootSaga),
    fork(notificationRootSaga),
    fork(confirmationRootSaga),
    fork(engineBuildsRootSaga),
    fork(downloadFileRootSaga),
  ]);
}



// WEBPACK FOOTER //
// ./src/client/store/reduxConfig/rootSaga.js